import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  MrSelect,
  MrCrudView,
  MrForm as WrappedMrForm,
  formatJsonApiData
} from "mr_react_framework";
import { actions } from "./redux";
import ProgrammeListItem from "./ProgrammeListItem/ProgrammeListItem";
import ProgrammesFilter from "./ProgrammesFilter/ProgrammesFilter";
import ProgrammeItemDetail from "./ProgrammeItemDetail/ProgramItemDetail";
import ProgrammeCustomInput from "./ProgrammeCustomInput";
// import WrappedMrForm from "../../lib/utils/MrForm/MrForm";
import commonSelectors from "App/commonSelectors";
// import SelectBoard from "components/AppSpecific/SelectBoard/SelectBoard";
import { actions as genericActions } from "App/genericRedux";
import ProgrammeList from "./ProgrammeList";
import MrTranslate, { mrTranslate } from "lib/MrTranslate/MrTranslate";

const SelectBoard = MrSelect({
  actions: genericActions,
  resourceName: "boards",
  config: {
    url: "/boards",
    // params: { key: "value" },
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.abbr, value: item.id };
      });
    },
    widgetConfig: {
      showSearch: false, // if false, this will either load entire data from backend on widget load or onSearch
      // TBD: If false, need to be able to search. Also if can do regular select from redux with this component, then can use same everywhere.
      placeholder: <MrTranslate id={"Programmes.select_board_placeholder"}/>,
      // mode: "multiple",
      style: { width: "500px" },
    },
  },
});

export const returnForm = (props) => {
  console.log("in programmes==>", props);
  const { mrIntl } = props

  let form = {
    processFormData: (dataProps, opts) => {
      console.log("dataProps", dataProps);
      console.log("opts", opts);
      
      return opts.values;
    },
    schema: {
      type: "object",
      properties: {
        name: {
          type: "string",
          placeholder: mrIntl("Programmes.program_name_placeholder"),
        },
        code: {
          type: "string",
          placeholder: mrIntl("Programmes.program_code_placeholder"),
        },
        abbr: {
          type: "string",
          placeholder: mrIntl("Programmes.abbr_placeholder"),
        },
        desc: {
          type: "string",
          placeholder: mrIntl("CommonText.description"),
        },
        board_id: {
          // title: "Select board",
          type: "string",
          span: 24,
          widget: SelectBoard,
        },
        // subject_title_display: {
        //   // title: "Select board",
        //   type: "string",
        //   span: 24,
        //   widget: (props) => {
        //     return "Subjects"
        //   },
        // },
        programme_subjects_attributes: {
          type: "array",
          addButtonTitle: `+ ${mrIntl("Programmes.add_new_subject_group_btn_text")}`,
          span: 24,
          min: 1,
          title: mrIntl("CommonText.subjects"),
          max: 100,
          items: {
            type: "object",
            properties: {
              name: {
                type: "string",
                title: mrIntl("Programmes.subject_group_name"),
                span: 8,
                rules: [
                  {
                    required: true,
                    message: mrIntl("CommonText.required_msg"),
                  },
                ]
              },
              code: {
                type: "string",
                title: mrIntl("CommonText.code"),
                // default: "2020-2021"
                span: 8,
                rules: [
                  {
                    required: true,
                    message: mrIntl("CommonText.required_msg"),
                  },
                ]
              },
              type_c: {
                type: "string",
                title: mrIntl("CommonText.type"),
                default: "group",
                span: 4,
                widget: "SelectWidget",
                widgetConfig: {
                  options: [
                    { label: mrIntl("CommonText.group"), value: "group" },
                    { label: mrIntl("CommonText.subject"), value: "subject" },
                  ]
                },
                rules: [
                  {
                    required: true,
                    message: mrIntl("CommonText.required_msg"),
                  },
                ]
              },
              children_attributes: {
                type: "array",
                addButtonTitle: `+ ${mrIntl("CommonText.add_new_subject")}`,
                span: 24,
                min: 1,
                max: 200,
                items: {
                  type: "object",
                  properties: {
                    name: {
                      type: "string",
                      title: mrIntl("CommonText.subject_name"),
                      span: 8,
                      rules: [
                        {
                          required: true,
                          message: mrIntl("CommonText.required_msg"),
                        },
                      ]
                    },
                    code: {
                      type: "string",
                      title: mrIntl("CommonText.code"),
                      // default: "2020-2021"
                      span: 8,
                      rules: [
                        {
                          required: true,
                          message: mrIntl("CommonText.required_msg"),
                        },
                      ]
                    },
                    type_c: {
                      type: "string",
                      title: mrIntl("CommonText.type"),
                      default: "subject",
                      span: 4,
                      widget: "SelectWidget",
                      widgetConfig: {
                        options: [
                          { label: mrIntl("Programmes.groups"), value: "group" },
                          { label: mrIntl("CommonText.subject"), value: "subject" },
                        ]
                      },
                      rules: [
                        {
                          required: true,
                          message: mrIntl("CommonText.required_msg"),
                        },
                      ]
                    },
                  }
                }
              },
            },
            
          }

        },
        // grade_title_display: {
        //   // title: "Select board",
        //   type: "string",
        //   span: 24,
        //   widget: (props) => {
        //     return "Grades"
        //   },
        // },
        programme_grades_attributes: {
          type: "array",
          span: 24,
          min: 1,
          max: 20,
          title: mrIntl("CommonText.grades"),
          items: {
            type: "object",
            properties: {
              name: {
                type: "string",
                placeholder: mrIntl("CommonText.name"),
                span: 6,
              },
              code: {
                type: "string",
                placeholder: mrIntl("CommonText.code"),
                // default: "2020-2021",
                span: 6,
              },
            },
            
          }

        },
        // subjects: {
        //   title: "Subjects",
        //   type: "string",
        //   default: "{}",
        //   widget: ProgrammeCustomInput
        // },
        // grades: {
        //   title: "Grades",
        //   type: "string",
        //   default: "{}",
        //   widget: ProgrammeCustomInput,
         
        // },

       
      },
    },
  };
  return form;
};

const processProgrammeFormInitialValues = (data) => {
  console.log( "initial data", data );
  let newData = data
  // let newData = {
  //   ...data,
  //   nestedValues: {
  //     ...data.nestedValues,
  //     tempNested: "tempNested updated"
  //   },
  //   name: "hello1"
  // }
  // data = nestedValues
  if(data.programme_subjects_attributes_for_static){
    let programmeSubjectsAttributes = formatJsonApiData(data.programme_subjects_attributes_for_static)
    newData.programme_subjects_attributes = programmeSubjectsAttributes
  }
  return newData;
} 

const Programmes = MrCrudView({
  resourceName: "programmes",
  singleResourceName: "programme",
  displayName: "resourceName",
  resourceUrl: "/programmes",
  // layout: OrgsLayout,
  filter: ProgrammesFilter,
  isRoute: true,
  selectorsObj: {
    ...commonSelectors,
  },
  listItem: ProgrammeListItem,
  forms: [
    { name: "programmes", form: returnForm, config: {
      processInitialValues: processProgrammeFormInitialValues
    } },
  ],
  actions,
  actionNames: ["fetch", "create", "show", "update", "delete"],
  // firstTimeFetchParams: { with_users: true }
  config: {
    itemPreview: {
      widget: ProgrammeListItem,
    },
    itemDetail: {
      // widget: (props) => {
      //   console.log( "itemDetail props", props );
      //   return <span>Item Detail {JSON.stringify(props.item)}</span>
      // }
      widget: ProgrammeItemDetail,
    },
    pagination: {
      show: true,
    },
    filter: {
      show: true,
      widget: (props) => {
        return <span><MrTranslate id={"CommonText.filter"}/></span>;
      },
    },
    core: {
      setQueryParams: true,
    },
    list: {
      show: true,
      // type: "table/list/custom",
      widget: ProgrammeList,
    }
  },
});

// Programmes.defaultProps = {};

Programmes.propTypes = {};
export default Programmes;
